<template>
  <div
    v-if="products.length"
    class="product-slider"
    :class="{
      // 'product-slider--hovered': isHovered,
      'product-slider--simple-card': simpleProductCard,
      'product-slider--toggle': isToggle,
      'product-slider--without-container': withoutContainer
    }" >
    <header class="product-slider__header">
      <div
        class="product-slider__title-wrap"
        @click="handleToggle">
        <h3 class="product-slider__title">{{ title }}</h3>
        <a
          v-if="link"
          @click.stop="handleLinkClick"
          :href="link"
          class="product-slider__more">
          {{ computedLinkTitle }}
        </a>
        <button
          v-if="isToggle"
          class="product-slider__toggle-btn"
          :class="{'product-slider__toggle-btn--rotate': !isShowingContent}">
          <svg
            width="12"
            height="8"
            viewBox="0 0 12 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1 6.9502L5.94975 2.00045L10.8995 6.9502"
              stroke="#333333"
              stroke-width="2"/>
          </svg>
        </button>
      </div>
    </header>
    <template v-if="isShowingContent">
      <CategoryFilter
        class="product-slider__filters"
        :data="filterData"
        @change-filter="handleChangeFilter" />
      <swiper
        class="swiper"
        :options="swiperOption"
        ref="mySwiper"
        @slideChange="onSlideChange">
        <div class="swiper-pagination swiper-pagination--slider" slot="pagination"></div>
        <div class="swiper-button-prev" :class="[transliterate(title) + '-prev']" slot="button-prev"></div>
        <div class="swiper-button-next" :class="[transliterate(title) + '-next']" slot="button-next"></div>
        <!--        <div-->
        <!--          class="product-slider__navigation"-->
        <!--          v-if="isShowingContent">-->
        <!--          <div-->
        <!--            class="swiper-button-prev"-->
        <!--            :class="[transliterate(title) + '-prev']"-->
        <!--            slot="button-prev"></div>-->
        <!--          <div-->
        <!--            class="swiper-button-next"-->
        <!--            :class="[transliterate(title) + '-next']"-->
        <!--            slot="button-next"></div>-->
        <!--        </div>-->
        <template v-for="(product, i) in computedProducts">
          <swiper-slide
            v-show="(!isServerPagination && currentCategoryId) ? product.category_id === currentCategoryId : true"
            class="swiper-item"
            :key="i">
            <ProductCard
              @onIntersecting="collectAnalyticsData($event)"
              :id="product.id"
              :position="i + 1"
              :is-preorder="product.is_preorder"
              :code="product.code.toString()"
              :title="product.title"
              :title-ru="product.title_ru"
              :title-analytics="product.title_ru"
              :category-id="product.category_id"
              :category-parent-id="product.category_parent_id"
              :link="product.link"
              :image-url="product.image_url"
              :second-image-url="product.second_image_url"
              :rating="product.rating"
              :reviews-count="product.reviews_count"
              :price="JSON.stringify(product.price)"
              :is-available="product.is_available"
              :is-novelty="product.is_novelty"
              :is-in-wait-list="product.is_in_wait_list"
              :is-in-wish-list="product.is_in_wish_list"
              :badges="JSON.stringify(product.badges)"
              :bottom-badge="product.bottom_badge"
              :options="product.options"
              :characteristics="product.characteristics ? product.characteristics : []"
              :arrival-date="product.arrival_date"
              :arrival-date-employee="product.arrival_date_employee"
              :block="transliterate(titleRu)"
              :analytics-data="product.analytics_data"
              :simple-card="simpleProductCard"
              :available-in-store="product.available_only_in_store_data"
              :without-buy="withoutBuy"
              :esputnik-data="product.esputnik_data"
              :esutnik-block-id="esputnikBlockId"
              :progressbar-total="product.progressbar_total"
              :progressbar-current="product.progressbar_current"
              slider
              not-adaptive
              adaptive-main-page
            />
          </swiper-slide>
        </template>
      </swiper>
    </template>
    <Loader :is-loading="isLoading" />
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

import { transliteration } from '@/mixins/transliteration'
import { isTouch } from '@/mixins/isTouchDevice'

import ProductCard from '../product-card/ProductCard'
import CategoryFilter from './CategoryFilter'
import api from '@/api'
import Loader from '@/components/helpers/Loader'
import { GoogleEnhancedEcommerce } from '@/services/AnalyticService'

export default {
  name: 'ProductsSlider',
  mixins: [transliteration, isTouch],
  props: {
    id: {
      type: [String, Number]
    },
    title: {
      type: String,
      default: ''
    },
    titleRu: {
      type: String,
      default: ''
    },
    titleAnalytics: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    linkTitle: {
      type: String,
      default: ''
    },
    products: {
      type: Array,
      default: () => []
    },
    showFilter: {
      type: Boolean,
      default: false
    },
    filterData: {
      type: Array,
      default: () => []
    },
    isServerPagination: {
      type: Boolean,
      default: false
    },
    dataForFixedBlock: {
      type: Object,
      default: () => {}
    },
    withoutContainer: {
      type: Boolean,
      default: false
    },
    withoutBuy: {
      type: Boolean,
      default: false
    },
    simpleProductCard: {
      type: Boolean,
      default: false
    },
    isToggle: {
      type: Boolean,
      default: false
    },
    sliderSpaceBetween: {
      type: Number,
      default: 0
    },
    sliderPerView: {
      type: Number,
      default: 1.5
    },
    linkClickPrevent: {
      type: Boolean,
      default: false
    },
    sliderBreakpoints: {
      type: Object,
      default: () => ({
        319: {
          slidesPerView: 1,
          slidesPerGroup: 1
        },
        359: {
          slidesPerView: 2,
          slidesPerGroup: 2
        },
        550: {
          slidesPerView: 3,
          slidesPerGroup: 3
        },
        1023: {
          slidesPerView: 4,
          slidesPerGroup: 4
        },
        1299: {
          slidesPerView: 5,
          slidesPerGroup: 5
        }
      })
    },
    esputnikBlockId: String
  },
  methods: {
    async sendAnalyticsData () {
      if (GoogleEnhancedEcommerce.isEnabled) {
        if (this.collectedAnalyticsData.length) {
          await GoogleEnhancedEcommerce.viewItemList({
            analyticsData: this.collectedAnalyticsData,
            listId: this.id,
            listName: this.titleAnalytics
          })
          this.collectedAnalyticsData = []
        }
      }
    },
    collectAnalyticsData (el) {
      this.collectedAnalyticsData.push(el)
    },
    handleChangeFilter (item) {
      this.currentCategoryId = item.id
    },
    handleToggle () {
      this.isShowContent = !this.isShowContent
    },
    handleLinkClick (e) {
      if (this.linkClickPrevent) {
        e.preventDefault()
        this.$emit('link-click')
      }
    },
    loadMoreProducts () {
      this.isLoading = true

      api.blocks.getFixedBlockProducts({
        id: this.id,
        offset: this.loadedInfo?.offset,
        categoryId: this.currentCategoryId
      }).then(res => {
        this.isLoading = false

        if (res.success) {
          this.loadedInfo = res
          this.loadedProducts = [...this.loadedProducts, ...res.data]
        }
      })
    },
    onSlideChange () {
      const activeIndex = this.swiper.swiperInstance.activeIndex

      if (activeIndex === this.activeIndexForLoad && this.loadedInfo?.['goods_left']) {
        this.loadMoreProducts()
        this.activeIndexForLoad += 9
      }
    }
  },
  components: {
    Loader,
    CategoryFilter,
    Swiper,
    SwiperSlide,
    ProductCard
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper
    },
    computedLinkTitle () {
      return this.linkTitle || this.$t('see_all')
    },
    isShowingContent () {
      return this.isToggle ? this.isShowContent : true
    },
    computedProducts () {
      if (this.isServerPagination) {
        return this.loadedProducts
      }

      return this.products
    }
  },
  data () {
    return {
      collectedAnalyticsData: [],
      isHovered: false,
      isShowContent: true,
      swiperOption: {
        watchOverflow: true,
        watchSlidesVisibility: true,
        spaceBetween: this.sliderSpaceBetween,
        slidesPerView: this.sliderPerView,
        breakpoints: this.sliderBreakpoints,
        pagination: {
          el: '.swiper-pagination--slider',
          type: 'progressbar'
        },
        navigation: {
          nextEl: '.' + this.transliterate(this.title) + '-next',
          prevEl: '.' + this.transliterate(this.title) + '-prev'
        },
        simulateTouch: !isTouch,
        touchStartPreventDefault: false,
        preloadImages: false,
        lazy: true
      },
      currentCategoryId: null,
      loadedInfo: this.dataForFixedBlock,
      loadedProducts: this.products,
      isLoading: false,
      shownSkeletons: 0,
      activeIndexForLoad: 1
    }
  },
  created () {
    if (this.isServerPagination) {
      this.loadMoreProducts()
      this.activeIndexForLoad += 9
    }
  },
  mounted () {
    const showUpsaleFromLocalStorage = this.$localStorage.get('show_upsale_in_cart')

    if (showUpsaleFromLocalStorage !== null) this.isShowContent = showUpsaleFromLocalStorage
  },
  watch: {
    collectedAnalyticsData () {
      setTimeout(() => {
        this.sendAnalyticsData()
      }, 1000)
    },
    currentCategoryId () {
      if (this.isServerPagination) {
        this.loadedInfo = {}
        this.loadedProducts = []
        this.activeIndexForLoad = 1
        this.loadMoreProducts()
      }
    }
  }
}
</script>

<style scoped lang="sass">
@import "~swiper/css/swiper.min.css"
@import "../../../styles/swiper/swiper"

.product-slider
  position: relative

.product-slider__header,
.product-slider__filters
  padding: 0 15px

.product-slider__filters
  margin-bottom: 20px

.swiper-container
  padding: 5px 0 0
  margin-top: -5px
  +mmin($tablet)
    padding: 5px 15px 0

.cart__wrapper .swiper-container
  padding: 0
  margin: 0 15px

.product-slider:not(.product-slider--simple-card)
  &:hover
    .swiper-slide, .swiper-button-next, .swiper-button-prev
      +mmin($tablet)
        pointer-events: all
    .swiper-container
      +mmin($tablet)
        z-index: 2
        padding-top: 5px
        padding-bottom: 300px
        margin-top: -5px
        margin-bottom: -300px
        pointer-events: none

.product-slider--without-container ::v-deep
  margin: 0 -15px

  .swiper-wrapper
    align-items: stretch
    .swiper-slide
      height: auto

.product-slider:not(.product-slider--simple-card)
  .swiper-slide-visible
    border: 1px solid #F3F3F3
    margin: 0 -2px 0 0

  .swiper-slide-visible + .swiper-slide:not(.swiper-slide-visible)
    border-left: 1px solid #f3f3f3

.product-slider__header
  display: flex
  flex-flow: row nowrap
  justify-content: space-between
  align-items: center
  margin-bottom: 15px

  +mmin($tablet)
    margin-bottom: 30px

.product-slider__title-wrap
  display: flex
  flex-flow: row wrap
  align-items: baseline
  justify-content: space-between
  width: 100%

  +mmin($tablet)
    width: auto
    justify-content: flex-start

.product-slider__title
  font-size: 18px
  font-weight: 500
  padding: 0
  margin: 0

  +mmin($tablet)
    font-size: 24px

.product-slider--toggle
  .product-slider__title-wrap
    justify-content: flex-start
    cursor: pointer

  .product-slider__title
    font-size: 16px

    +mmin($tablet)
      font-size: 20px

.product-slider__more
  color: $main-color
  font-size: 14px
  font-weight: 400 //Rubik 300

  +mmin($tablet)
    font-size: 16px
    margin-left: 20px

  &:hover,
  &:focus,
  &:active
    color: $main-color--hover

.product-slider__toggle-btn
  display: block
  border: none
  padding: 0
  margin: 0 0 0 10px
  background: transparent

  &--rotate
    transform: rotate(180deg)
.swiper-button-prev
  left: 30px
  top: 200px
  +mmax($tablet)
    display: none
.swiper-button-next
  right: 30px
  top: 200px
  +mmax($tablet)
    display: none

//.product-slider__navigation
//  display: none
//  position: absolute
//  left: 30px
//  width: calc(100% - 60px)
//  z-index: 5
//  transform: translateY(-50%)
//  top: 50%
//
//  +mmin($tablet)
//    display: block
.swiper-pagination--slider
  width: 100%
  left: 0
  height: 3px
  top: 6px
  background: #E7E7E7
  +mmin($tablet)
    width: calc(100% - 30px) !important
    left: 15px !important
.cart__wrapper
  .swiper-button-next
    right: 15px !important
  .swiper-button-prev
    left: 15px !important
  .swiper-pagination--slider
    top: 0 !important
    +mmin($tablet)
      width: 100% !important
      left: 0 !important
      top: 0 !important
</style>

<style lang="sass">
.product-slider
  .swiper-button-prev.swiper-button-disabled, .swiper-button-next.swiper-button-disabled
    pointer-events: all
    cursor: not-allowed
  .swiper-wrapper
    align-items: stretch
  .swiper-slide
    height: auto
.swiper-pagination--slider
  .swiper-pagination-progressbar-fill
    background: #FF2F00 !important
</style>
